<template>
  <div class="form-page">
    <div class="text-white text-center pt-5">
      <h2>Login</h2>
      <p>
        Need an account?
        <router-link to="/signup" class="text-warning ms-3">Signup</router-link>
      </p>
    </div>
    <form
      @submit.prevent="handleSubmit"
      class="log-sign-form d-flex flex-column bg-white text-dark"
    >
      <div v-if="error" class="error mb-2">
        <p class="text-danger mb-1 text-center">
          Your email or password is incorrect, Please try again.
        </p>
      </div>

      <label for="email" class="mb-1 text-warning">Email:</label>
      <input
        type="email"
        name="email"
        v-model="email"
        placeholder="Email address"
        required
        class="mb-3 p-2"
      />

      <label for="password" class="mb-1 text-warning">Password:</label>
      <input
        type="password"
        name="password"
        v-model="password"
        placeholder="Password"
        required
        class="mb-3 p-2"
      />

      <button class="btn btn-warning mb-3">Login</button>
      <div v-if="error" class="error2">
        <p class="">
          New to My Book List?
          <router-link to="/signup" class="text-warning">Signup</router-link>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import useLogin from "../composables/useLogin";
export default {
  setup() {
    const { login, error } = useLogin();
    const router = useRouter();
    const email = ref("");
    const password = ref("");
    const handleSubmit = async () => {
      await login(email.value, password.value);
      if (!error.value) {
        router.push("/");
      }
    };
    return { email, password, handleSubmit, error };
  },
};
</script>

<style>
.log-sign-form {
  margin: 0 auto;

  margin-top: 50px;
  width: 20rem;
  max-width: 90%;
  border-radius: 5px;
  position: relative;
  z-index: 1;
  background: #fff;
  overflow: hidden;
  padding: 50px;
}

input {
  border: 0;
  border-bottom: 1px solid #555;
  width: 100%;
  font-size: 16px;
}

input:focus,
textarea:focus {
  border: none;
  outline: none;
  border-bottom: 1px solid #ffc107;
  background-color: #fff9e6;
}

.error {
  border: 1px solid #d9534f;
  background-color: #f7dddc;
  padding: 3px;
  border-radius: 5px;
}

.error2 {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding-top: 10px;
}
</style>
